import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import LandingTemplate from "./LandingTemplate";
import { LANDING_PAGES } from "./landing-pages-config";

/**
 * Renders one of the SEO/authority landing pages from the central
 * LANDING_PAGES config. The route in App.js can pass `slug` either as a
 * URL param or as a fixed string prop.
 */
export default function LandingPage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;
  const navigate = useNavigate();

  const config = LANDING_PAGES[slug];
  if (!config) {
    // Soft 404
    return (
      <div className="min-h-screen bg-[#080807] text-[#f4efe6]">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 py-24">
          <h1 className="font-serif-display text-3xl">Page not found</h1>
          <button onClick={() => navigate("/")} className="mt-4 text-[#b8963e] hover:underline">
            ← Back home
          </button>
        </div>
      </div>
    );
  }
  return <LandingTemplate {...config} />;
}
